import flatpickr from "flatpickr";
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";
import { German } from "flatpickr/dist/l10n/de.js"
import getOccupancy from './occupancy';
import _throttle from "lodash.throttle";

Date.prototype.addDays = function(days) {
  const date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

const checkRange = (date,ranges) => {
  for (let j = 0; j < ranges.length; ++j) {
    const dates = getRange(ranges[j].from,ranges[j].to);

    for (let i = 0; i < dates.length; ++i) {
      if(new Date(date).getTime() === new Date(dates[i]).getTime()) {
        return true;
      }
    }

  }

  return false;
};

const getRange = (startDate, stopDate) => {
  const dateArray = [];
  let currentDate = startDate;

  while (currentDate <= stopDate) {
    dateArray.push(new Date (currentDate));
    currentDate = currentDate.addDays(1);
  }
  return dateArray;
}

const handleDatepickr = (picker) => {
  const mq = window.matchMedia('(min-width: 1024px)')

  if (mq.matches === true) {
    picker.set('showMonths', 2);
  } else if (mq.matches === false) {
    picker.set('showMonths', 1);
  }

  picker.redraw();
};

const datepicker = () => {

  const pickers = document.querySelectorAll('.c-input__control--datepickr')
  if(pickers) {
    pickers.forEach(picker => {

      let fPicker;

      fPicker = flatpickr(picker, {
        plugins: [
          new rangePlugin({ input: '.c-input__control--datepickr--end',})
        ],
        altInput: true,
        altFormat: "d.m.Y",
        dateFormat: "d.m.Y",
        mode: 'range',
        showMonths: 2,
        minDate: "today",
        position: 'above',
        inline: true,
        static: true,
        monthSelectorType: 'static',
        onChange: function(dateObj, dateStr) {
          if (picker._flatpickr.selectedDates) {
            const dates = getRange(picker._flatpickr.selectedDates[0], picker._flatpickr.selectedDates[1]);
            if(dates) {
              for (let i = 0; i < dates.length; ++i) {
                if(checkRange(dates[i], picker._flatpickr.config.disable)) {
                  picker._flatpickr.clear()
                }
              }
            }
          }
        },
        'locale': German // locale for this instance only
      });

      const wrapper = picker.closest('.date-range-wrapper');
      const pElm = picker.closest('.flatpickr-wrapper');

      if(wrapper && pElm) {
        wrapper.appendChild(pElm);

        const inputWrapper = wrapper.querySelector('.wpcf7-form-control-wrap.date-range-start');
        const input = wrapper.querySelector('.c-input__control--datepickr[name="date-range-start"] + input[type="text"]');
        if(inputWrapper && input) {
          inputWrapper.appendChild(input);
        }
      }

      if (picker._flatpickr) {

        const disabledDates = getOccupancy();
        disabledDates.then(res => {
          const fp = picker._flatpickr;
          fp.set('disable', res.data);
        });

        handleDatepickr(picker._flatpickr);
        window.addEventListener('resize', () => {
          handleDatepickr(picker._flatpickr);
        }, false);
      }

    });
  }

}
datepicker();
